<template>
  <div :style="{'width': width}" :class="[pureSelectClassName,isUndefined(isShowOption) ? '' : isShowOption ? 'show-option' : 'hide-option', 'select-wrapper']">
    <div :style="{ 'height': isShowOption ? dropdownHeight : height}" :class="['select-wrap']" @click="toggleOption">
      <div  :style="{'height': height}"  :class="[{ 'need-clear': allowClear && label }, 'current-select-text-content']">
        <label title="label" class="select-wrap-label">
          {{ label ? label : placeholder }}
        </label>
        <div class="select-dropdown-icon">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAMCAMAAAC6EAb3AAAATlBMVEUAAACAgICAgICAgICBgYGBgYGAgICAgICAgICBgYGAgICBgYGCgoKBgYGAgICAgICBgYGBgYGBgYGAgICAgICAgICAgICBgYGAgIB/f3/2vj+UAAAAGXRSTlMA8fvscEz253hnXzw2MOGGVEMo2ragin8kYP0wGwAAAGNJREFUGNNdylkOgCAQBNEGxH3Fte9/UcdMkEB9vhTO2SNv2A84Wp+joYG3rDekRkP2wJrxJNgBykNEpyj1lmbEVxCsFIWpHBqyxV9HugmPYqoS9jN5AwVLC4pawQuxdDfpfAHnYwWbwoap8AAAAABJRU5ErkJggg==" alt="" />
        </div>
        <div v-if="allowClear && label" class="clear-select" @click.stop="clearSelect">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAb1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABt6r1GAAAAJHRSTlMA5+I7J/NDu3FgDwg/OEVSfO7KsKRsFenPtKmoWOzOhEoeGY8PzpSpAAABoklEQVRIx62W6ZaCMAyFWVopWBYFBcHRWfL+zzgDJ0NtIVhzvP/M4TOXkKYJ3qxM6FRVlUq1yPwpoYbbAVCH26CED7UvawmOZF3un2HpEVZ1TDfROAFSSUxzJwkbkieqkg08UbNa4bOxSds9ExyDzC7gpYvrtgFPNU49wVtWbXPpD8rccPsEXlBieiiFl5TOCe3+DAFFhY7/KUsrfBfX0MGu4scKlAjWj8HoOwh0aHE6CL6sSI3nVlpF+/wLFa0JtMVoyn5GTKACS9FY7l0459vNP43UBPbgkBofnbnC4aCfurQDl4xnt21h50N1Y8cKnEtLt8anq8P4khpQbs5d26LPpTTRNugWfRLNo4AkCQ7LWsGqwoksPmBVFRtkW90sThxvFkdTXB6GOf056AaIo/EPqAYgWg45gsSWC4a1Js8jk3zpdqCOFeYjcyrqIOvIMXC1OCmI0ZFHroXl6FgOq0qUkWO+FPflsOKPR/5A5l8B/EuHf83xL9YgSzxfMOMvDwvy4rE6nLkLEn8l4y+B/LWTv+jSEqrvzGrd9Uowl/n36hdF/xGFZHjBSwAAAABJRU5ErkJggg==" alt="" />
        </div>
      </div>
      <div type="horizontal" class="border-line"></div>
      <div class="search_wrap"  v-if="!hiddenSearch">
      <input
        :placeholder="searchInputPlaceholder"
        :style="{'height': searchInputHeight}"
        v-model="searchTxt"
        @click.stop="disableClick"
        class="search_input"
        type="text"
      />
      <img class="search_icon" :style="{'width': searchIconWidth}"  :src="searchIcon" alt="">
      </div>
      <div
        ref="select-option-wrap"
        :class="[{ 'select-option-wrap-with-no-search': hiddenSearch }, 'select-option-wrap']"
      >
        <div class="select-option-content" ref="scrollbar">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isUndefined } from '@/utils/typeCheck'
import scrollIntoView from '@/utils/scrollIntoView'

export default {
  name: 'PureSelect',
  provide() {
    return {
      parent: this,
    }
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    width: {
      type:  String,
      default: '160px',
    },
    searchIcon:{
       type:  String,
      default: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAiCAYAAADRcLDBAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIaADAAQAAAABAAAAIgAAAABR4PrQAAAC4UlEQVRYCcWXy4tPYRjHjfslRoiQzCiEomZBWcgfMG4L2VvJytKGZi1Le4thOUpR7gtWpFwzNWJcSrnktnP3+ZT31zPHOXPO+c3x861v53lv3/d5r897uiZVQxfVNsBtsBd2w5/wAxyB1+Bz+E+wANWj8DH8VcLblB+As2Bj2I+SIy3rPFs+Spv+Ol44zVnMIWMQ7skUOP2Odhi+hlPgEtgH18MIHTsOD0Pb1YJTeRPG0X0iPQCXwyKspeAE/AJj21Ok8wZKdjGGKIoil0i7L6piDRWdqahxpGpj67kHYmOXZJoFNTGX+ldg0vqKvbmKhqONm/A8ade8XcyjYZyRe6Qnl4l5DJPn7oE6S1CkvYUCN2XS3VlU0Xw3TrwHBsxsCGfRSU5cHE9zY6j4A3vFeJVrlu0I2p4cj38uDpKbvL2VW6P9zBk0/Rz0t+ZJuVl6Q8GjYDdhOvonQSj21crWCYNRgjdh03gTBGNfrWydiNfqRI5lSzRjRE3vjL+gE94PCcaCphE13+WJ68RIKOgLdhOmt+fqIPQy2GPMlaTS6fBrMGoKexFK2m+xHXQhDNGpstGwKVxHKOmeLhP1RZQqe6yMhhPFbgSSpl+v8XHhO2IUpkbD2K5nu+ihoUcz6V2uKtRPxRhwDMdGw7pYRoP7MDnwETv3kioSPhYaK+KMlE5jENuF/QomB/weCuWVTHevT7Io4uwYDQ1GxoIsnK19MG7C2N5l8XehFgztPsm83aKYtsHoDjQsu1wPoBs5W+9bJs/ZifcFyWrwSeaLKNtBWfocbdbBwUzbF6RXwdpweXwROfK8ESeH3lN+Esa35FTSZ2Cq4/cZ7IFj4NRXhQ+STdCd3g2/Q5+CXvueBh9EWUwnYwh68hKeYmyHhVd4qtjk1818AcYZ8TnpUe4ovAyvwuiID6jFHfWCzlzOGzA6cpf0QthRzKe3GCzd8DM76sGfzhbxfQhdHpfpv2EpPc9Ovf8GA3X4vkOwcUQAAAAASUVORK5CYII=',
    },
    searchIconWidth: {
      type:  String,
      default: '10px',
    },
     height: {
      type:  String,
      default: '40px',
    },
    dropdownHeight: {
      type:  String,
      default: '250px',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    hiddenSearch: {
      type: Boolean,
      default: true,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    pureSelectClassName: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    searchInputHeight: {
      type: String,
      default: '30px',
    },
    searchInputPlaceholder: {
      type: String,
      default: 'search',
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowOption: undefined,
      option: [],
      selectDom: {},
      searchTxt: '',
      selectData: {
        label: '',
        value: '',
      },
    }
  },
  computed: {
    label() {
      return this.option ? this.option.find((item) => item.value == this.value)?.label : undefined
    },
  },

  methods: {
    disableClick() {
      return
    },
    clearSelect() {
      this.selectDom = {}
      this.searchTxt = ''
      this.selectData = {
        label: '',
        value: '',
      }
    },
    toggleOption() {
      this.searchTxt = ''
      this.isShowOption = !this.isShowOption
      this.scrollToOption(this.selectDom)
    },
    isUndefined,

    scrollToOption(option) {
      this.$nextTick(() => {
        let target = option.$el
        if ((this.$refs['select-option-wrap'] && target) || this.value !== '') {
          const menu = this.$refs['select-option-wrap'].querySelector('.select-option-content')
          Array.prototype.forEach.call(menu.children, (item) => {
            if (this.label === item.innerText) {
              target = item
            }
          })
          scrollIntoView(menu, target)
        }
      })
    },
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.isShowOption = undefined
      }
    })
  },
  watch: {
    selectData: {
      handler(val) {
        this.$emit('change', val.value)
        this.isShowOption = undefined
      },
      deep: true,
    },
    '$route.path'() {
      this.isShowOption = undefined
    },

    searchTxt() {
      this.$emit('search', this.searchTxt)
    },
  },
}
</script>

<style lang="less" scoped>
.border-line {
  background: rgba(0, 0, 0, 0.1);
  z-index: 9;
  width: calc(100% - 20px);
  margin: auto;
  transform: scaleY(0.5);
  height: 1px;
  transform-origin: 50% 100%;
  flex-shrink: 0;
}
.select-wrapper {
  background: #fff;
  height: 40px;
  width: 160px;
  position: relative;
  color: #000;
  position: relative;
  cursor: pointer;
  user-select: none;
}
.need-clear {
  &:hover {
    .clear-select {
      opacity: 0.5;
      z-index: 10;
    }
    .select-dropdown-icon {
      opacity: 0;
    }
  }
}
.select-dropdown-icon {
  height: 6px;
  width: 10.55px;
  transform-origin: center;
  transition: 0.1s;

  z-index: 10;
}
.select-dropdown-icon img {
  width: 100%;
  display: block;
}
.current-select-text-content {
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding:0 10px;
  flex-shrink: 0;
  position: relative;
}

.show-option {
  .search_wrap {
    display: block;
  }
}
.hide-option {
  .search_wrap {
    display: none;
  }
}
.select-wrap {
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  transform-origin: top right;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  line-height: 1;
  color: #000;
  cursor: pointer;
  z-index: 9;
  overflow: hidden;
  
  display: flex;
  flex-direction: column;

}
.select-header-input {
  border: none;
  width: 100%;
  height: auto;
  font-size: 13px;
  padding: 0;
  cursor: inherit;
  &::placeholder {
    color: #000000;
    font-size: 13px;
  }
  &:focus {
    outline: none;
  }
}

.select-option-wrap {
  z-index: 1;
  width: 100%;
  background: #fff;
  opacity: 1;
  flex-grow: 1;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow-y:auto ;
}
.search_wrap{
  position: relative;
  margin: 5px auto;
  flex-shrink: 0;
  width: 100%;

}
.search_icon{
  position: absolute;
  right: 20px;
  top: 50%;
  opacity:0.6;
  pointer-events: none;
  transform: translateY(-50%);
}

.search_input {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 5px;
  margin: auto;
  width: calc(100% - 20px);
  box-sizing: border-box;
  font-size: 12px;
  font-family: 'Pf-Regular';
  font-weight: 400;
  display: block;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
  }
}
.clear-select {
  width: 15px;
  height: 15px;
  position: absolute;
  z-index: 9;
  top: 50%;
  transform: translateY(-50%);
  right: 9px;
  opacity: 0;
  transition: 0.1s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  img {
    width: 100%;
    display: block;
  }
}

.select-option-content {
  width: calc(100% - 3px);
  overflow-y: auto;
  height: calc(100% - 5px);
  &::-webkit-scrollbar {
    width: 4px; //对垂直方向滚动条
    height: 4px; //对水平方向滚动条
  }
  //滚动的滑块
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #E4E4E4//滚动条的颜色;
  }
  //内层滚动槽
  &::-webkit-scrollbar-track-piece {
    background-color: #fff;
  }
}
.select-wrap-label {
  cursor: pointer;
  font-family: 'Pf-Regular';
  font-size: 13px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  user-select: none;
     white-space: nowrap; 
    overflow: hidden;      
    text-overflow: ellipsis;   
}
.select-option-wrap-with-no-search {
  height: 100%;
}
</style>
